import React from 'react';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="border-t bg-white py-4 px-6">
      <div className="flex items-center justify-between text-sm text-gray-600">
        <p>© {currentYear} CuesHealth Provider Portal. All rights reserved.</p>
        <div className="flex gap-6">
          <a href="#" className="hover:text-gray-900 transition-colors">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-gray-900 transition-colors">
            Terms of Service
          </a>
          <a href="#" className="hover:text-gray-900 transition-colors">
            Help & Support
          </a>
        </div>
      </div>
    </footer>
  );
};